import React, { Component } from 'react';
import { Alert } from 'reactstrap';

class AlertSuccess extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          visible: true
        };
    
        this.onDismiss = this.onDismiss.bind(this);
      }
    
      onDismiss() {
        this.setState({ visible: false });
      }

  render() {
    return (
        <Alert color={this.props.color} isOpen={this.props.visible} toggle={this.props.onDismiss}>
            {this.props.alertText}
      </Alert>
    )
  }
}
AlertSuccess.defaultProps = {
  alertText: "",
  color:"success",
}
export default AlertSuccess;



// WEBPACK FOOTER //
// ./src/shared/components/Alerts/alert_success.js